module.exports = "https://web-assets-production.autolist.com/_next/static/images/truck-04698d71b62317475da69b5af16dfb90.jpg";